import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=01d9d673&scoped=true"
import script from "./PageResult.vue?vue&type=script&lang=js"
export * from "./PageResult.vue?vue&type=script&lang=js"
import style0 from "./PageResult.vue?vue&type=style&index=0&id=01d9d673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d9d673",
  null
  
)

export default component.exports